module.exports = __webpack_public_path__ + "static/media/sodexo.a30969ba.png";